import FilterWidget from "./FilterWidget";

export default FilterWidget;
